export default __webpack_public_path__ + "static/media/flat-chevron.63b3d6b5.svg";